import { Component,ViewChild, ElementRef} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AppState } from '../../../app/app.global';
declare var AMap;

@Component({
  selector: 'page-map',
  templateUrl: 'map.html',
})
export class MapPage {
  @ViewChild('map_container') map_container: ElementRef;
  map: any;//地图对象
  constructor(public navCtrl: NavController,public global: AppState, public navParams: NavParams) {
  }

  ionViewDidEnter() {
      this.map = new AMap.Map(this.map_container.nativeElement, {
        view: new AMap.View2D({//创建地图二维视口
          zoom: 11, //设置地图缩放级别
          rotateEnable: true,
          showBuildingBlock: true
        })
      });
   }


}



// WEBPACK FOOTER //
// ./src/pages/test/map/map.ts